import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetDressCodeErrorAction implements Action {
  public static readonly type = 'GetDressCodeErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetDressCodeErrorAction.type;
}
